import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import * as _ from 'lodash';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalApplicationModule } from './msal-application.module';
import { MsalRedirectComponent } from '@azure/msal-angular';
//import { CustomMSALInterceptor } from './http-interceptors/CustomMSALInterceptor';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    RouterModule,
    HttpClientModule,
    AppRoutingModule,
    MsalApplicationModule.forRoot('assets/config/configuration.json'),
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],
  declarations: [AppComponent, AdminLayoutComponent, AuthCallbackComponent],

  //providers: [{ provide: HTTP_INTERCEPTORS, useClass: CustomMSALInterceptor, multi: true }],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
